import React from "react";
import Utils from "../../utils/utils";
import { CiUser } from "react-icons/ci";
import { TbCalendarTime } from "react-icons/tb";

const AssignmentCard = ({ props }) => {
  const { assignment, index, handleItemToView, user } = props;

  return (
    // <div
    //   bkl="AssignmentCard"
    //   key={assignment._id + "Assignment"}
    //   className="bg-white relative rounded-xl shadow-lg
    //   overflow-hidden flex flex-wrap md:flex-nowrap xs:flex-none
    //    hover:shadow-2xl transition-shadow duration-300"
    // >
    //   <div
    //     className="
    //     absolute left-0 top-0 h-full w-1 bg-gradient-to-b from-pink-600 to-pink-800"
    //   />

    //   <div
    //     className="p-4 w-full md:w-1/2 xs:w-full transition-all duration-300 flex flex-col justify-between"
    //     bkl="Description"
    //     key="Description"
    //   >
    //     <div>
    //       <h3 className="text-lg font-semibold text-gray-700 truncate">
    //         {assignment.title}
    //       </h3>
    //       <p className="text-gray-600 text-sm mt-2">
    //         <span className="font-medium">Description: </span>
    //         {assignment.description}
    //       </p>
    //       <div className="flex items-center gap-1 mt-2">
    //         <div
    //           className={`h-6 w-6 text-sm rounded-full flex items-center justify-center overflow-hidden ${
    //             assignment.instructorName
    //               ? Utils.getRandomBgColor() + " text-white"
    //               : ""
    //           }`}
    //         >
    //           {assignment.instructorName ? (
    //             Utils.getUserAvatar(assignment.instructorName)
    //           ) : (
    //             <CiUser className="w-4 h-4" />
    //           )}
    //         </div>
    //         <div className="font-normal text-sm text-[#544D4F]">
    //           {assignment.instructorName}
    //         </div>
    //       </div>

    //       <div className="flex items-center gap-1 mt-2">
    //         <div className="h-7 w-7 rounded-full flex justify-center items-center overflow-hidden">
    //           <TbCalendarTime className="w-5 h-5" />
    //         </div>
    //         <p className="font-normal text-sm">
    //           <span>Concludes on </span>
    //           <span className="text-red-500">
    //             {user &&
    //               user.batch &&
    //               Utils.formatDateTime(assignment.dueDates[user.batch])}
    //           </span>
    //         </p>
    //       </div>
    //       {assignment.remarks && (
    //         <p className="text-gray-500 text-xs mt-2 italic">
    //           Remarks: {assignment.remarks}
    //         </p>
    //       )}
    //     </div>

    //     <div className="bg-white  p-3 flex items-center justify-between mt-2">
    //       <button
    //         className="text-sm px-4 py-2 uppercase border border-pink-700 text-pink-800 rounded-md
    //           hover:text-pink-900 hover:tracking-[0.05rem] hover:text-semibold  transition-all duration-200"
    //         onClick={(e) => {
    //           e.preventDefault();
    //           handleItemToView(assignment, index);
    //         }}
    //       >
    //         View Assignment
    //       </button>
    //       <p className="text-gray-400 text-xs">Assigned</p>
    //     </div>
    //   </div>

    //   <div
    //     className="flex-1 p-4 w-full md:w-1/2 border-t md:border-t-0 shadow-inner bg-gray-50
    //     transition-all duration-300 flex flex-col justify-between"
    //     bkl="QuestionsCard"
    //     key="QuestionsCard"
    //   >
    //     <h4 className="text-gray-700 text-sm font-medium">Questions:</h4>
    //     <ul
    //       className="mt-2 flex-1 max-h-full p-2 overflow-y-auto
    //       scrollbar-thumb-gray-200 scrollbar-none rounded-md"
    //     >
    //       {assignment.questions.map((q, i) => (
    //         <li className="text-gray-600 text-sm mb-2" key={i}>
    //           <span className="font-medium">{i + 1}. </span> {q.question}
    //         </li>
    //       ))}
    //     </ul>
    //   </div>
    // </div>

    <div
      bkl="AssignmentCard"
      key={assignment._id + "Assignment"}
      className="bg-white relative rounded-xl shadow-lg overflow-hidden flex flex-wrap md:flex-nowrap xs:flex-none 
  hover:shadow-2xl transition-shadow duration-300 h-[300px]" // Fixed height
    >
      <div className="absolute left-0 top-0 h-full w-1 bg-gradient-to-b from-pink-600 to-pink-800" />

      <div
        className="p-4 w-full md:w-1/2 xs:w-full flex flex-col justify-between overflow-hidden"
        bkl="Description"
        key="Description"
      >
        <div className="overflow-hidden">
          <h3 className="text-lg font-semibold text-gray-700 truncate">
            {assignment.title}
          </h3>
          <p className="text-gray-600 text-sm mt-2 line-clamp-3">
            <span className="font-medium">Description: </span>{" "}
            {assignment.description}
          </p>

          <div className="flex items-center gap-1 mt-2">
            <div
              className={`h-6 w-6 text-sm rounded-full flex items-center justify-center overflow-hidden ${
                assignment.instructorName
                  ? Utils.getRandomBgColor() + " text-white"
                  : ""
              }`}
            >
              {assignment.instructorName ? (
                Utils.getUserAvatar(assignment.instructorName)
              ) : (
                <CiUser className="w-4 h-4" />
              )}
            </div>
            <div className="font-normal text-sm text-[#544D4F]">
              {assignment.instructorName}
            </div>
          </div>

          <div className="flex items-center gap-1 mt-2">
            <div className="h-7 w-7 rounded-full flex justify-center items-center overflow-hidden">
              <TbCalendarTime className="w-5 h-5" />
            </div>
            <p className="font-normal text-sm">
              <span>Concludes on </span>
              <span className="text-red-500">
                {user &&
                  user.batch &&
                  Utils.formatDateTime(assignment.dueDates[user.batch])}
              </span>
            </p>
          </div>

          {assignment.remarks && (
            <p className="text-gray-500 text-xs mt-2 italic">
              Remarks: {assignment.remarks}
            </p>
          )}
        </div>

        <div className="bg-white p-3 flex items-center justify-between mt-2">
          <button
            className="text-sm px-4 py-2 uppercase border border-pink-700 text-pink-800 rounded-md
        hover:text-pink-900 hover:tracking-[0.05rem] hover:text-semibold transition-all duration-200"
            onClick={(e) => {
              e.preventDefault();
              handleItemToView(assignment, index);
            }}
          >
            View Assignment
          </button>
          <p className="text-gray-400 text-xs">Assigned</p>
        </div>
      </div>

      <div
        className="flex-1 p-4 w-full md:w-1/2 border-t md:border-t-0 shadow-inner bg-gray-50 transition-all duration-300 
    flex flex-col h-full"
        bkl="QuestionsCard"
        key="QuestionsCard"
      >
        <h4 className="text-gray-700 text-sm font-medium">Questions:</h4>
        <ul className="mt-2 flex-1 max-h-[270px] p-2 overflow-y-auto scrollbar-thumb-gray-200 scrollbar-none rounded-md">
          {assignment.questions.map((q, i) => (
            <li className="text-gray-600 text-sm mb-2" key={i}>
              <span className="font-medium">{i + 1}. </span> {q.question}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default AssignmentCard;
